/**
 * New function was needed to add the statuses into the query parameters as a list of strings.
 * Url-Template package was sending only one string, with a comma separating the values, e.g: status=st1,st2,st3...
 * We want to send a list of strings to the backend and for that, we need this format: status=st1&status=st2&status=st3...
 * 
 * @param paramName - query parameter name
 * @param baseUrl - the base url (may contain already some query parameters)
 * @param values - list of strings with the values that we want to filter on
 * 
 * @returns a string in the following format: status=st1&status=st2&status=st3...
 */
const addListToQueryParams = (paramName: string, baseUrl: string, values: string[]) => {
  values.forEach(val => {
    baseUrl += `&${paramName}=${val}`
  });
  return baseUrl;
}

export { addListToQueryParams };
